import { Box, Container, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../components/CustomButton";
import { useNavigate } from "react-router-dom";

const Donate = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&to=kimberley@eaglelearning.org&su=Hello%20I'm%20from%20your%20website&body=Edit%20the%20email%20%20body.",
      "_blank"
    );
  };

  return (
    <>
      <Box sx={{ width: "100vw" }}>
        {/* Donate Header Text Section */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { md: "50vh" },
            justifyContent: "center",
            alignItems: "center",
            my: { xs: 10, md: 2.5 },
          }}
        >
          <Typography
            variant="h2"
            maxWidth={"350px"}
            my={4}
            textAlign={"center"}
          >
            <span style={{ color: "#DB5430" }}>Journey</span> With{" "}
            <span style={{ color: "#DB5430" }}>Us</span>
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", width: { xs: "100%", md: "90%" } }}
          >
            As the famous African proverb states, "If you want to go fast, go
            alone. If you want to go far, go together." At EAGLE, we're
            committed to going far by empowering individuals and communities to
            unlock their God-given potential. We recognize that EAGLE cannot
            achieve this mission alone - we need to journey together.
            Partnership takes many forms, and that's what makes these
            relationships so valuable. From volunteering your time or resources
            to becoming a mentor, you can join us in making a meaningful
            difference today and an impact for eternity.
          </Typography>
        </Container>

        {/* Donate Option Buttons */}
        <Container
          sx={{
            height: { md: "50vh" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            mb: 5,
            cursor: "pointer",
          }}
        >
          <Box
            onClick={() => navigate("/donations/give")}
            sx={{
              width: "100%",
              height: "inherit",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "primary.main",
              py: { xs: 5 },
            }}
          >
            <Typography variant="h2" mb={2}>
              Donate
            </Typography>
            <Typography
              variant="body1"
              textAlign={"center"}
              color="white"
              width={"70%"}
            >
              EAGLE’s own journey of impact cannot be walked alone. Every
              partner and connection is vital in multiplying EAGLE’s impact
              within local communities.
            </Typography>
          </Box>
          <Box
            onClick={() => navigate("/donations/inkind")}
            sx={{
              width: "100%",
              height: "inherit",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "secondary.main",
              py: { xs: 5 },
            }}
          >
            <Typography variant="h2" color="primary.main" mb={2}>
              Volunteer
            </Typography>
            <Typography
              variant="body1"
              textAlign={"center"}
              color="white"
              width={"70%"}
            >
              EAGLE is all about lifelong learning, which is why we get so
              excited about volunteering with us - there is no better learning
              than learning by doing.
            </Typography>
          </Box>
          <Box
            onClick={() => navigate("/donations/join")}
            sx={{
              width: "100%",
              height: "inherit",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              py: { xs: 5 },
            }}
          >
            <Typography variant="h2" mb={2} color="primary.secondary">
              Join
            </Typography>
            <Typography
              variant="body1"
              textAlign={"center"}
              color="#222222"
              width={"70%"}
            >
              Whether you are a child or an adult, you are always learning, and
              EAGLE creates a platform to enhance your opportunities to holistic
              learn for life.
            </Typography>
          </Box>
        </Container>

        {/* Contact us now section */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "40vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h7">Contact us now</Typography>
          <Typography
            variant="h2"
            maxWidth={"400px"}
            my={4}
            textAlign={"center"}
          >
            Do you need to{" "}
            <span style={{ color: "#DB5430" }}>contact our team now?</span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "40%",
            }}
          >
            <CustomButton onClick={handleClick}>
              <Typography sx={{ mx: { md: 5 } }}>Contact us</Typography>
            </CustomButton>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Donate;
